import avatar from '../../images/avatar.svg';

import {Completable, UsersWebDTO} from 'kashable-mobile-common';

const getAvatar = (user: Completable<UsersWebDTO>) => {
    if (user.value && user.value.has_avatar) {
        // TODO: get user avatar
        // return '/secured/user/avatar';
        return avatar;
    }
    return avatar;
};

const isSelfServiceFedGov = (user:UsersWebDTO) => {
    const workflow = user.workflow;
    if(workflow){
        return ['FEDGOV', 'SELF_SERVICE', 'RETIREE', 'ATOMIC', 'PINWHEEL'].some(wf => workflow.startsWith(wf));
    }

    return false;
}

export {getAvatar, isSelfServiceFedGov};